import { render, staticRenderFns } from "./Kid.vue?vue&type=template&id=57cb763d&"
import script from "./Kid.vue?vue&type=script&lang=js&"
export * from "./Kid.vue?vue&type=script&lang=js&"
import style0 from "./Kid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports